// Copyright (c) StrangeBee 2024

import { Spin } from 'antd';
import React, { ReactElement } from 'react';

import './LoadedContent.scss';

const LoadedContent = (): ReactElement => (
    <div className="loaded-content">
        <Spin tip="Loading..." />
    </div>
);

export default LoadedContent;
